import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { ProductSummarySearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportBillProductSummary, sortBillProductSummary } from '../../constants';
import { getBillProductSummary, getAllBillProductSummary } from '../../actions';
import { makeGetListBillProductSummary } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
// import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;
const sizeDownloadAll = 1000;

class ProductSummary extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listBillProductSummary: [],
    listAllProductSummary: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listBillProductSummary: props.listBillProductSummary,
      totalCount: getPageTotalCount({ ...state, items: props.listBillProductSummary }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetBillProductSummaryReport },
    } = this.props;
    if (modeGetBillProductSummaryReport) {
      this.doGetListBillProductSummary();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListBillProductSummary();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListBillProductSummary());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListBillProductSummary());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListBillProductSummary();
    });
  };

  doGetListBillProductSummary = () => {
    const { filter, page, size, sorted } = this.state;
    const { getBillProductSummary } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortBillProductSummary[sorted.sortCol]
          ? sortBillProductSummary[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getBillProductSummary(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistBillProductSummary = cb => {
    const { filter, sorted } = this.state;
    // const { getAllBillProductSummary } = this.props;
    const payload = {
      page: 1,
      size: sizeDownloadAll,
      filter,
      sort: !isEmpty(sorted) ? sortBillProductSummary[sorted.sortCol][sorted.sortDir] : null,
    };
    // getAllBillProductSummary(payload, () => {
    //   if (cb) cb();
    // });
    this.doSearchAllProductSummary(payload, cb);
  };

  doSearchAllProductSummary = (payload, cb) => {
    const { getAllBillProductSummary } = this.props;
    const newPayload = payload;
    getAllBillProductSummary(newPayload, ({ success, data }) => {
      const { listAllProductSummary } = this.state;
      if (success && data && data.length) this.setState({ listAllProductSummary: [...listAllProductSummary, ...data] });
      if (success && data && data.length === sizeDownloadAll) {
        newPayload.page += 1;
        this.doSearchAllProductSummary(newPayload, cb);
      } else if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistBillProductSummary(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { t } = this.props;
        const { listAllProductSummary } = this.state;

        convertJson2Pdf({
          data: listAllProductSummary,
          t,
          title: t('reportPage:sidebar.productSummary').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.productSummary')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 4,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistBillProductSummary(() => {
      const { t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;
      const { listAllProductSummary } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_BILL_PRODUCT_SUMMARY_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.productSummary')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.productSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllProductSummary,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              accountType: 'accountType',
              billType: 'billUnitType',
              billStatus: 'invoiceStatus',
              paymentMethod: 'paymentMethod',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllProductSummary,
          t,
          title: t('reportPage:sidebar.productSummary').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.productSummary')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 4,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.productSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('PRODUCT_SUMMARY_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportBillProductSummary,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listBillProductSummary,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
      listAllProductSummary,
    } = this.state;
    const {
      t,
      permissions: { modeGetBillProductSummaryReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetBillProductSummaryReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.productSummary') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.productSummary')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <ProductSummarySearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.productSummary').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllProductSummary,
                          t,
                          title: t('reportPage:sidebar.productSummary').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.productSummary')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listBillProductSummary}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listBillProductSummary && listBillProductSummary.length ? listBillProductSummary : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

ProductSummary.propTypes = {
  getBillProductSummary: PropTypes.func,
  getAllBillProductSummary: PropTypes.func,
  // listAllBillProductSummary: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

ProductSummary.defaultProps = {
  getBillProductSummary: () => {},
  getAllBillProductSummary: () => {},
  // listAllBillProductSummary: [],
};

const mapStateToProps = createStructuredSelector({
  listBillProductSummary: makeGetListBillProductSummary() || [],
  // listAllBillProductSummary: makeGetListAllBillProductSummary() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getBillProductSummary,
    getAllBillProductSummary,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(ProductSummary)
);
